import React, { forwardRef, type Ref } from 'react';
import AddIcon from '@atlaskit/icon/core/add';
import { IconButton } from '@atlaskit/button/new';

import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	onClick?: () => void;
	isCreateWorkItem?: boolean;
};

const getWorkItemMessage = () =>
	fg('jira-issue-terminology-refresh-m3') ? messages.createWorkItem : messages.createIssue;

const CreateChildButton = forwardRef(
	({ onClick, isCreateWorkItem }: Props, ref: Ref<HTMLButtonElement>) => {
		const { formatMessage } = useIntl();

		return (
			<IconButton
				spacing="compact"
				appearance="subtle"
				label={
					isCreateWorkItem
						? formatMessage(getWorkItemMessage())
						: formatMessage(messages.createChildItem)
				}
				testId="issue-table-hierarchy.ui.create-child-button.create"
				icon={(iconProps) => <AddIcon {...iconProps} size="small" />}
				onClick={onClick}
				isTooltipDisabled={false}
				ref={ref}
			/>
		);
	},
);

export default CreateChildButton;
